import { ROUTES } from '~/utils/routes';
import { useUserDetailHeader } from './hooks';
import { UserDetailHeaderPresentation } from './presentations';

type Props = {
  userId: number;
};

/**
 * 利用者詳細ヘッダー Container コンポーネント
 * API から取得した利用者名をパンくずリスト付きヘッダーに表示する
 */
export const UserDetailHeader: React.FC<Props> = ({ userId }) => {
  const { fullName } = useUserDetailHeader({ userId });

  return <UserDetailHeaderPresentation fullName={fullName} indexHref={ROUTES.USERS} />;
};
